import { render, staticRenderFns } from "./BaseSelectPagination.vue?vue&type=template&id=1bf5b27d&scoped=true"
import script from "./BaseSelectPagination.vue?vue&type=script&lang=js"
export * from "./BaseSelectPagination.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectPagination.vue?vue&type=style&index=0&id=1bf5b27d&prod&lang=css"
import style1 from "./BaseSelectPagination.vue?vue&type=style&index=1&id=1bf5b27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5b27d",
  null
  
)

export default component.exports